export * from './ArrowAUpIcon';
export * from './ArrowAUpIcon16Light';
export * from './ArrowAUpIcon16Regular';
export * from './ArrowAUpIcon16Solid';
export * from './ArrowAUpIcon20Light';
export * from './ArrowAUpIcon20Regular';
export * from './ArrowAUpIcon20Solid';
export * from './ArrowAUpIcon24Regular';
export * from './ArrowAUpIcon24Solid';
export * from './ArrowAUpIcon32Regular';
export * from './ArrowAUpIcon64Regular';
